import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {PhotoService} from '../../../modules/photo/services/photo.service';

@Injectable({
    providedIn: 'root'
})
export class SuccessGuardService implements CanActivate {

    constructor(private photoService: PhotoService, private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const id = route.params['id'];

        return this.photoService.getPhotoDetails(id, false).then(
            response => {
                if (response['Data'] == null) {
                    this.router.navigate(['/']);

                    return false;
                } else {
                    return true;
                }
            },
            err => {
                console.log('getPhotoDetails error ' + err);
                return false;
            }
        );
    }
}
